import { Component,ChangeDetectorRef, signal } from '@angular/core';
import { FirstSelectionComponent } from '../first-selection/first-selection.component';
import { SharedDataService } from '../../Services/SharedServices/shared-data.service';
import { NemaService } from '../../Services/nema.service';
import { environment } from '../../../Environment/environment';
import { Router } from '@angular/router';
@Component({
  selector: 'app-third-selection',
  templateUrl: './third-selection.component.html',
  styleUrl: './third-selection.component.css'
})
export class ThirdSelectionComponent{
  scrollToCommonSecondComponent() {
    const hpSecondComponent = document.querySelector('app-second-selection');
    if (hpSecondComponent) {
      hpSecondComponent.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  signalStatus:boolean=false;
  panelOpenState = signal(this.signalStatus);
  constructor(private service:NemaService,private sharedDataService: SharedDataService,private cdr: ChangeDetectorRef,private router: Router) {
    this.AssetbasePath = environment.assetsPath;
  }
  AssetbasePath:any;
  seriesSelectedArray: any;
  public HpSpecDataResponse: any = {};
  public formSelectionData: any = {};
  Size:any;
  SpecServiceFactor: any;
  currentReducerSize:any;
  currentReducerRatio:any;
  currentReducerSpeed:any;
  SpecificationData:any;
  Series:any;
   public showspinfo: boolean = false;
  public showcdinfo: boolean = false;
  // constructor(){}
  
  // super();
  ngOnInit(): void {
    const currentUrl = window.location.href.toLowerCase();
  if (currentUrl.includes('spineatools') ) {
      this.showspinfo = true;
      this.showcdinfo = false;
    } else {
      this.showspinfo = false;
      this.showcdinfo = true;
    }
    this.sharedDataService.series$.subscribe(series => {
      this.signalStatus=true;
    this.panelOpenState = signal(this.signalStatus);
      console.log('Series received in HomeComponent:', series);
      if (series) {
        this.Series = series;
      }
    });
   console.log("My Shared Data Bengins");
    this.sharedDataService.formData$.subscribe((formData) => {
      this.formSelectionData={
        SelectedInputPower:formData.selectedInputPower || "Null",
        SelectedUnits:formData.selectedUnits || "Null",
        SelectedSpeed:formData.selectedSpeed || "Null",
        SelectedRatio:formData.selectedRatio || "Null",
        SelectedDutyCycle:formData.selectedDutyCycle || "Null",
        SelectedServiceFactor:formData.selectedServiceFactor || "Null",
        SelectedOutputSpeed:formData.selectedOutputSpeed || "Null"

      };
      console.log("My Form Selected Data from step 3 in HP", this.formSelectionData);
      this.seriesSelectedArray = formData;
      console.log("My Shared Data");
      console.log(JSON.stringify(formData, null, 2));
      
      });
      console.log("My Shared Data ends");
    this.sharedDataService.HpSpecData$.subscribe((HpSpecData:any) => 
    {
      this.HpSpecDataResponse={
        IppowerMechImp:(HpSpecData.ippowerMechImp=="N/A")?HpSpecData.ippowerMechImp:HpSpecData.ippowerMechImp + " hp"||"Null",
        IppowerMechMet:(HpSpecData.ippowerMechMet=="N/A")?HpSpecData.ippowerMechMet:HpSpecData.ippowerMechMet + " kW"||"Null",
        IptorqueImp:(HpSpecData.iptorqueImp=="N/A")?HpSpecData.iptorqueImp:HpSpecData.iptorqueImp + " lb-in"||"Null",
        IptorqueMet:(HpSpecData.iptorqueMet=="N/A")?HpSpecData.iptorqueMet:HpSpecData.iptorqueMet + " Nm"||"Null",
        IptorqueAccellImp:(HpSpecData.iptorqueAccellImp=="N/A")?HpSpecData.iptorqueAccellImp:HpSpecData.iptorqueAccellImp + " lb-in"||"Null",
        IptorqueAccellMet:(HpSpecData.iptorqueAccellMet=="N/A")?HpSpecData.iptorqueAccellMet:HpSpecData.iptorqueAccellMet + " Nm"||"Null",
        IppowerthermalImp:(HpSpecData.ippowerthermalImp=="N/A")?HpSpecData.ippowerthermalImp:HpSpecData.ippowerthermalImp + " hp"||"Null",
        IppowerthermalMet:(HpSpecData.ippowerthermalMet=="N/A")?HpSpecData.ippowerthermalMet:HpSpecData.ippowerthermalMet + " kW"||"Null",
        IppowerFanThermalImp:(HpSpecData.ippowerFanThermalImp=="N/A")?HpSpecData.ippowerFanThermalImp:HpSpecData.ippowerFanThermalImp + " hp"||"Null",
        IppowerFanThermalMet:(HpSpecData.ippowerFanThermalMet=="N/A")?HpSpecData.ippowerFanThermalMet:HpSpecData.ippowerFanThermalMet + " kW"||"Null",
        OptorqueImp:(HpSpecData.optorqueImp=="N/A")?HpSpecData.optorqueImp:HpSpecData.optorqueImp + " lb-in"||"Null",
        OptorqueMet:(HpSpecData.optorqueMet=="N/A")?HpSpecData.optorqueMet:HpSpecData.optorqueMet + " Nm"||"Null",
        OptorqueAccellImp:(HpSpecData.optorqueAccellImp=="N/A")?HpSpecData.optorqueAccellImp:HpSpecData.optorqueAccellImp + " lb-in"||"Null",
        OptorqueAccellMet:(HpSpecData.optorqueAccellMet=="N/A")?HpSpecData.optorqueAccellMet:HpSpecData.optorqueAccellMet + " Nm"||"Null",
        Efficiency:(HpSpecData.efficiency=="N/A")?HpSpecData.efficiency:HpSpecData.efficiency + "%"|| "Null",
        specServiceFactor:(HpSpecData.specServiceFactor=="N/A")?HpSpecData.specServiceFactor : HpSpecData.specServiceFactor
      };
      
    // if(this.formSelectionData.Units=="metric"){
    //   this.SpecServiceFactor =this.HpSpecDataResponse.ippowerMechMet;
    // }
    // else{
    //   this.SpecServiceFactor =this.HpSpecDataResponse.ippowerMechImp;
    // }

    });
    
    this.sharedDataService.SizeData$.subscribe((SizeData:any) => 
    {
      this.Size = SizeData
      console.log("Size from step 2 in step 3"+JSON.stringify(SizeData, null, 2));
    });
  }
  largerReducer(): void {
  //  this.SpecServiceFactor = this.formSelectionData.SelectedInputPower;
    console.log("Testing Larger Reducer");
    const size = document.getElementById("size") as HTMLInputElement
    const ratio = document.getElementById("ratio") as HTMLSelectElement;
    const selectedOption = ratio.options[ratio.selectedIndex];
    
    const speed = document.getElementById("speed") as HTMLInputElement
    const inputPower = document.getElementById("inputPower") as HTMLInputElement
    const unit = document.getElementById("unit") as HTMLInputElement
    
    console.log(this.currentReducerSize+"Test size");
    const reducerData = {
      // size : "500",
      size : size.innerHTML,
      ratio : selectedOption.innerHTML,
      speed : speed.innerHTML,
      Inputpower_Them:inputPower.value,
      units:unit.innerHTML
    };
    
    this.getHpLargerReducer(reducerData);
  }
  smallerReducer(): void {
   
    const size = document.getElementById("size") as HTMLInputElement
    // const ratio = document.getElementById("ratio") as HTMLInputElement
    const ratio = document.getElementById("ratio") as HTMLSelectElement;
    const selectedOption = ratio.options[ratio.selectedIndex];
    const speed = document.getElementById("speed") as HTMLInputElement
    const inputPower = document.getElementById("inputPower") as HTMLInputElement
    const unit = document.getElementById("unit") as HTMLInputElement
    const reducerData = {
      // size : "500",
      size : size.innerHTML,
      ratio : selectedOption.innerHTML,
      speed : speed.innerHTML,
      Inputpower_Them:inputPower.value,
      units:unit.innerHTML
    };

    this.getHpSmallerReducer(reducerData);
  }


  public getHpLargerReducer(request: any):void{
   
    this.service.getHpLargerReducer(request).subscribe(result=>{
      // this.sharedDataService.setHPSpecificationData(result.body);
      console.log("THis is my own Size data initial one", this.Size);
      if(result.body ==null){
        alert("No larger Size available")
      }else{
        this.UpdateReducerData(result.body);
      }
      console.log(result.body);
      
    });
  }





  public getHpSmallerReducer(request: any):void{
   
    this.service.getHpSmallerReducer(request).subscribe(result=>{
      // this.sharedDataService.setHPSpecificationData(result.body);
      if(result.body ==null){
        alert("No Smaller Size available")
      }else{
        this.UpdateReducerData(result.body);
      }
      console.log(result.body);
      
    });
  }
  public UpdateReducerData(request:any):void{
    const size = document.getElementById("size") as HTMLInputElement

    const IppowerMechImp = document.getElementById("IppowerMechImp") as HTMLInputElement
    const IppowerMechMet = document.getElementById("IppowerMechMet") as HTMLInputElement
    const IptorqueImp = document.getElementById("IptorqueImp") as HTMLInputElement
    const IptorqueMet = document.getElementById("IptorqueMet") as HTMLInputElement
    const IptorqueAccellImp = document.getElementById("IptorqueAccellImp") as HTMLInputElement
    const IptorqueAccellMet = document.getElementById("IptorqueAccellMet") as HTMLInputElement
    const IppowerthermalImp = document.getElementById("IppowerthermalImp") as HTMLInputElement
    const IppowerthermalMet = document.getElementById("IppowerthermalMet") as HTMLInputElement
    const IppowerFanThermalMet = document.getElementById("IppowerFanThermalMet") as HTMLInputElement
    const IppowerFanThermalImp = document.getElementById("IppowerFanThermalImp") as HTMLInputElement
    const OptorqueImp = document.getElementById("OptorqueImp") as HTMLInputElement
    const OptorqueMet = document.getElementById("OptorqueMet") as HTMLInputElement
    const OptorqueAccellImp = document.getElementById("OptorqueAccellImp") as HTMLInputElement
    const OptorqueAccellMet = document.getElementById("OptorqueAccellMet") as HTMLInputElement
    const EfficiencyImp = document.getElementById("EfficiencyImp") as HTMLInputElement
    const EfficiencyMet = document.getElementById("EfficiencyMet") as HTMLInputElement
    const specSF = document.getElementById("specSF") as HTMLInputElement
    const specSFElements = document.getElementsByClassName('sericeFactorStyle');
    size.innerHTML = request.cd;
    IppowerMechImp.innerHTML = request.ippowerMechImp+ " hp";
    IppowerMechMet.innerHTML = request.ippowerMechMet+ " kW";
    IptorqueImp.innerHTML = request.iptorqueImp+ " lb-in";
    IptorqueMet.innerHTML = request.iptorqueMet+ " Nm";
    IptorqueAccellImp.innerHTML = request.iptorqueAccellImp+ " lb-in";
    IptorqueAccellMet.innerHTML = request.iptorqueAccellMet+ " Nm";
    IppowerthermalImp.innerHTML = request.ippowerthermalImp+ " hp";
    IppowerthermalMet.innerHTML = request.ippowerthermalMet+ " kW";
    if(IppowerFanThermalImp!=null){
      IppowerFanThermalImp.innerHTML = (request.ippowerFanThermalImp=="N/A")?request.ippowerFanThermalImp:request.ippowerFanThermalImp+" hp";
      IppowerFanThermalMet.innerHTML = (request.ippowerFanThermalMet=="N/A")?request.ippowerFanThermalMet:request.ippowerFanThermalMet+" kW";
    }
    OptorqueImp.innerHTML = request.optorqueImp+ " lb-in";
    OptorqueMet.innerHTML = request.optorqueMet+ " Nm";
    OptorqueAccellImp.innerHTML = request.optorqueAccellImp+ " lb-in";
    OptorqueAccellMet.innerHTML = request.optorqueAccellMet+ " Nm";
    EfficiencyImp.innerHTML = request.efficiency +"%";
    EfficiencyMet.innerHTML = request.efficiency +"%";
    specSF.innerHTML = request.specServiceFactor;
    debugger;
    for (let i = 0; i < specSFElements.length; i++) {
        const element = specSFElements[i] as HTMLElement;
        // if (specSF.innerHTML[0] == "0") {
          if (Number(specSF.innerHTML) < Number(this.formSelectionData.SelectedServiceFactor)) {
            element.style.setProperty('background-color', '#dc3545', 'important');
        } else {
            element.style.setProperty('background-color', '#28a745', 'important');
        }
    }
  }


  public reducerFeature():void{
    debugger;
    const size = document.getElementById("size") as HTMLInputElement
    const ratio = document.getElementById("ratio") as HTMLSelectElement;
    const selectedOption = ratio.options[ratio.selectedIndex];
    const inputSpeed = document.getElementById("speed") as HTMLInputElement
    const IppowerMechImp = document.getElementById("IppowerMechImp") as HTMLInputElement
    const IppowerMechMet = document.getElementById("IppowerMechMet") as HTMLInputElement
    const IptorqueImp = document.getElementById("IptorqueImp") as HTMLInputElement
    const IptorqueMet = document.getElementById("IptorqueMet") as HTMLInputElement
    const IptorqueAccellImp = document.getElementById("IptorqueAccellImp") as HTMLInputElement
    const IptorqueAccellMet = document.getElementById("IptorqueAccellMet") as HTMLInputElement
    const IppowerthermalImp = document.getElementById("IppowerthermalImp") as HTMLInputElement
    const IppowerthermalMet = document.getElementById("IppowerthermalMet") as HTMLInputElement
    const IppowerFanThermalMet = document.getElementById("IppowerFanThermalMet") as HTMLInputElement
    const IppowerFanThermalImp = document.getElementById("IppowerFanThermalImp") as HTMLInputElement
    const OptorqueImp = document.getElementById("OptorqueImp") as HTMLInputElement
    const OptorqueMet = document.getElementById("OptorqueMet") as HTMLInputElement
    const OptorqueAccellImp = document.getElementById("OptorqueAccellImp") as HTMLInputElement
    const OptorqueAccellMet = document.getElementById("OptorqueAccellMet") as HTMLInputElement
    const EfficiencyImp = document.getElementById("EfficiencyImp") as HTMLInputElement
    const EfficiencyMet = document.getElementById("EfficiencyMet") as HTMLInputElement
    // console.log(IptorqueAccellImp.innerHTML);
    const data={
      size:size.innerHTML,
    IppowerMechImp:IppowerMechImp.innerHTML,
    IppowerMechMet:IppowerMechMet.innerHTML,
    IptorqueImp:IptorqueImp.innerHTML,
    IptorqueMet:IptorqueMet.innerHTML,
    IptorqueAccellImp:IptorqueAccellImp.innerHTML,
    IptorqueAccellMet:IptorqueAccellMet.innerHTML,
    IppowerthermalImp:IppowerthermalImp.innerHTML,
    IppowerthermalMet:IppowerthermalMet.innerHTML,
    // IppowerFanThermalImp: (request.ippowerFanThermalImp=="N/A")?request.ippowerFanThermalImp:request.ippowerFanThermalImp+" hp";
    // IppowerFanThermalMet: (request.ippowerFanThermalMet=="N/A")?request.ippowerFanThermalMet:request.ippowerFanThermalMet+" kW";
    
    IppowerFanThermalImp:IppowerFanThermalImp==null?"":IppowerFanThermalImp.innerHTML,
    IppowerFanThermalMet:IppowerFanThermalMet==null?"":IppowerFanThermalMet.innerHTML,
    OptorqueImp:OptorqueImp.innerHTML,
    OptorqueMet:OptorqueMet.innerHTML,
    OptorqueAccellImp:OptorqueAccellImp.innerHTML,
    OptorqueAccellMet:OptorqueAccellMet.innerHTML,
    EfficiencyImp:EfficiencyImp.innerHTML,
    EfficiencyMet:EfficiencyMet.innerHTML
    };
    console.log(size.innerHTML);
    console.log(EfficiencyMet.innerHTML);
    this.getSpecificationFinalData(data);

    var imageUrl
      if(data.size=="15"){
        imageUrl=this.AssetbasePath+"/Content/HPImages/First.png";
      }else if((data.size=="20")||(data.size=="25")){
        imageUrl=this.AssetbasePath+"/Content/HPImages/Second.png";
      }else{
        imageUrl=this.AssetbasePath+"/Content/HPImages/Third.png";
      }
    this.sharedDataService.setSizeToReducerFeature(size.innerHTML, selectedOption.innerHTML, inputSpeed.innerHTML,imageUrl);
  }

  public getSpecificationFinalData(request: any):void{
    // this.service.getHpSpecification(request).subscribe(result=>{
      this.sharedDataService.setAllSpecificationData(request);
      
    // });
  }

  


}
